enum InventoryType {
  //Mapped to participantId
  TICKET = "TICKET",

  //Mapped to btaAdminParticipantId
  BULK_TICKET = "BULK_TICKET",

  //Mapped to programParticipantId
  PROGRAM_REGISTRATION = "PROGRAM_REGISTRATION",

  //Mapped to btaAdminParticipantId
  BULK_PROGRAM_REGISTRATION = "BULK_PROGRAM_REGISTRATION",

  //Mapped to participantId
  RECURRING_PROGRAM_REGISTRATION = "RECURRING_PROGRAM_REGISTRATION",

  //Mapped to programOrganizationId
  MEETING = "MEETING",

  BUNDLED_MEETING = "BUNDLED_MEETING",

  //Mapped to eventOrganizationId
  SPONSORSHIP_MYEXP_PRIMARY = "SPONSORSHIP_MYEXP_PRIMARY",

  //Mapped to eventOrganizationId
  SPONSORSHIP_CATEGORY = "SPONSORSHIP_CATEGORY",

  //Mapped to eventOrganizationId
  SPONSORSHIP_APP = "SPONSORSHIP_APP",

  //Mapped to eventOrganizationId
  SPONSORSHIP_VIDEO = "SPONSORSHIP_VIDEO",

  //Mapped to eventOrganizationId
  SPONSORSHIP_TT_TOPIC = "SPONSORSHIP_TT_TOPIC",

  //Mapped to productId
  PRODUCT = "PRODUCT",

  //Mapped to boothId
  BOOTH = "BOOTH",

  TICKET_CHANGE = "TICKET_CHANGE",
  TICKET_UPGRADE = "TICKET_UPGRADE",

  // Additional Charge Inventory Types start
  TICKET_CHARGE = "TICKET_CHARGE",
  MEETING_CHARGE = "MEETING_CHARGE",
  BUNDLED_MEETING_CHARGE = "BUNDLED_MEETING_CHARGE",
  BULK_TICKET_CHARGE = "BULK_TICKET_CHARGE",
  // Additional Charge Inventory Types end
  ADD_ONS = "ADD_ONS",
  ADD_ONS_CHARGE = "ADD_ONS_CHARGE"
}

export const OnlyAmountRefundableInvetoryTypes: Array<InventoryType> = [
  InventoryType.TICKET,
  InventoryType.TICKET_CHARGE,
  InventoryType.MEETING_CHARGE,
  InventoryType.BUNDLED_MEETING_CHARGE,
  InventoryType.BULK_TICKET_CHARGE,
  InventoryType.TICKET_CHANGE,
  InventoryType.TICKET_UPGRADE
];

export const AutoLoginOnPurchaseInventoryTypes: Array<InventoryType> = [
  InventoryType.TICKET,
  InventoryType.TICKET_CHANGE
];

// Inventory types for which Admin can't approve offline transfer at PO level
export const OfflineTransferNotApprovableAtPoInventoryTypes: Array<InventoryType> = [
  InventoryType.TICKET,
  InventoryType.BULK_TICKET
];

export default InventoryType;
